type AxiosTimeoutContext = {
  action: string
  method: string
  timeout?: number
  params?: unknown
  data?: unknown
  status?: number
}

function isAxiosTimeoutError(error: any): boolean {
  if (!error) return false
  if (error.code === 'ECONNABORTED') return true
  return /timeout/i.test(String(error.message || ''))
}

/**
 * Rewrites Axios timeout errors so Sentry groups by Moleculer action name,
 * without polluting the message with URL query params or path IDs.
 */
export function enrichAxiosTimeoutError(error: any) {
  if (!isAxiosTimeoutError(error) || !error?.config) {
    return error
  }

  const method = String(error.config.method || 'get').toUpperCase()
  const action = error.config.action || 'unknown'
  const timeout = error.config.timeout
  const context: AxiosTimeoutContext = {
    action,
    method,
    timeout,
    params: error.config.params,
    data: error.config.data,
    status: error.response?.status,
  }

  error.message = `Timeout when calling ${action}`
  error.timeoutContext = context
  return error
}

export function applyAxiosTimeoutContextToSentryEvent(event: any, error: any) {
  const context = error?.timeoutContext as AxiosTimeoutContext | undefined
  if (!context) {
    return event
  }

  event.fingerprint = ['AxiosTimeout', context.action]
  event.tags = {
    ...event.tags,
    'http.method': context.method,
    'moleculer.action': context.action,
    'axios.timeout_ms': String(context.timeout ?? ''),
  }
  event.contexts = {
    ...event.contexts,
    axios: context,
  }
  return event
}
